import React from 'react';
import PropTypes from 'prop-types';
import { default as ReactSelect } from 'react-select';

export default function Select({
  items,
  value,
  name,
  placeholder,
  onSelectChange
}) {
  return (
    <ReactSelect
      options={items}
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={onSelectChange}
      styles={{}}
    />
  );
}

Select.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  value: PropTypes.object,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  onSelectChange: PropTypes.func
};

Select.defaultProps = {
  items: [],
  value: null,
  placeholder: '',
  onSelectChange: () => {}
};
